export const vns = {
    listagem: {
        titulo_pagina: 'Lista de VNS\'s',
        novo: 'Criar novo VNS',
        table: {
            empty: "Nenhum VNS encontrado",
            habilitado: 'Habilitado',
            desabilitado: 'Desabilitado',
            nome: 'Nome',
            empresa: 'Empresa',
            integracao_origem: 'Integração Origem',
            integracao_destino: 'Integração Destino',
            modem: {
                label: 'Modem',
                serial: 'Serial',
                empresa: 'Empresa',
                chip: 'Chip',
                limit: 'Limite',
                alerta: 'Alerta',
                consumo: 'Consumo',
            },
            numero_gps: 'Número',
            sensor_temperatura: 'Sensor de Temperatura',
            estado: 'Estado',
            monitor: 'Monitor',
            acoes: 'Ações',
            editar: 'Editar'
        }
    },
    permissoes: {
        index: {
            nome: 'Nome',
            acoes: 'Ações'
        },
        form: {
            titulo_pagina: 'Editar Permissões',
            botao_salvar: 'Salvar Permissões',
            update: {
                success: "Permissões atualizadas com Sucesso!",
                error: "Error ao atualizar Permissões!"
            }
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Criar novo VNS',
            editar: 'Editar VNS'
        },
        create:{
            success: 'VNS Criado com Sucesso',
            error: 'Erro ao Criar VNS!'
        },
        update:{
            success: 'VNS Atualizado com Sucesso',
            error: 'Erro ao Atualizar VNS'
        },
        fieldsets: {
            informacoes: 'Informações',
            integracoes: 'Integrações',
            perifericos: 'Periféricos'
        },
        fields: {
            nome: {
                label: 'Nome',
                description: 'Nome do VNS'
            },
            empresa: {
                label: 'Empresa',
                description: 'Empresa ao qual pertence o VNS'
            },
            unidade: {
                label: 'Unidade',
                description: 'Unidade de atendimento da empresa'
            },
            setor: {
                label: 'Setor',
                description: 'Setor da unidade de atendimento'
            },
            estado: {
                label: 'Estado',
                description: 'Estado em que se encontra o VNS'
            },
            integracao_origem: {
                label: 'Integração Origem',
                description: 'Qual a origem da integração'
            },
            credencial_origem: {
                label: 'Credencial Origem',
                description: 'Credencial da Origem da Integração'
            },
            integracao_destino: {
                label: 'Integração Destino',
                description: 'Qual o destino da integração'
            },
            credencial_destino: {
                label: 'Credencial Destino',
                description: 'Credencial do Destino da Integração'
            },
            integracao_impressao: {
                label: 'Integração de Impressão',
                description: 'Qual a Integração de Impressão'
            },
            credencial_impressao: {
                label: 'Credencial de Impressão',
                description: 'Credencial de Impressão'
            },
            atributos: {
                label: 'Atributos',
                description: 'Atributos utilizados para Integração'
            },
            modem: {
                label: 'Modem',
                description: 'Status do modem do VNS (ativo ou inativo)',
                dados: 'Informações do Modem',
                serial: {
                    label: 'Serial',
                    description: 'Serial do modem do VNS'
                },
                numero_chip: {
                    label: 'Número',
                    description: 'Número do chip do Modem'
                },
                empresa: {
                    label: 'Empresa',
                    description: 'Empresa do Modem'
                },
                data_limit: {
                    label: 'Limite de Dados',
                    description: 'Limite de dados do Modem'
                },
                data_alert: {
                    label: 'Alerta de Dados',
                    description: 'Número de dados para alerta do Modem'
                },
                data_consumption: {
                    label: 'Consumo',
                    description: 'Consumo do Modem'
                }
            },
            gps: {
                label: 'GPS',
                description: 'Status do GPS do VNS (ativo ou inativo)',
                numero: {
                    label: 'Número',
                    description: 'Número do GPS'
                }
            },
            sensor_temperatura: {
                label: 'Temperatura',
                description: 'Status do Sensor de temperatura do VNS (ativo ou inativo)'
            },
            status: {
                label: 'Status',
                description: 'Status do VNS (ativo ou inativo)'
            },
            monitor: {
                label: 'Monitor',
                description: 'Mostrar no Monitor de VNS (ativo ou inativo)'
            },
            botao_salvar: 'Salvar VNS'
        }
    },
    ranges: {
        listagem: {
            novo: 'Criar novo Range',
            table: {
                empty: "Nenhum Range encontrado",
                editar: "Editar",
                valor_inicial: 'Valor Inicial',
                valor_final: 'Valor Final',
                fundo: "Cor de Fundo",
                letra: "Cor da Letra"
            }
        },
        form: {
            titulo_pagina: {
                criar: 'Criar novo Range',
                editar: 'Editar Range'
            },
            fields: {
                inicio: 'Inicio do Range',
                final: 'Final do Range',
                fundo: {
                    label: 'Cor do Range',
                    description: 'Cor de fundo do range'
                },
                escrita: {
                    label: 'Cor da Escrita',
                    description: 'Cor da letra do Range'
                },
                botao_salvar : 'Salvar Range'
            },
            create: {
                success: "Range criado com Sucesso!",
                error: "Error ao criar Range!"
            },
            update: {
                success: "Range editado com Sucesso!",
                error: "Error ao editar Range!"
            }
        }
    },
}

export const monitoramento = {
    titulo_automacao: 'VNS Automação',
    titulo_display: 'VNS Display',
    titulo_quick: 'VNS Quick',
    titulo_link: 'VNS Link',
    titulo_all: 'Listagem de VNS',
    tipos_integracao: {
        impressora: 'Impressora',          
        automacao: 'Automação',          
        lis: 'LIS',          
        display: 'Display',         
        generic: 'Generic',          
        quick: 'Quick',          
        his: 'HIS',          
        label: 'Label',          
        temp: 'Temperatura',
        indefinido: 'Indefinido'
    },
    resumo: {
        tabs: {
            informacoes: {
                title: 'Informações',
                list: {
                    tipo: 'Tipo',
                    integracao: 'Integração',
                    impressora: 'Impressora',
                    sensor: 'Sensor de Temperatura',
                    enviados: 'Dados Enviados',
                    recebidos: 'Dados Recebidos'
                }
            },
            comandos: {
                title: 'Comandos',
                versoes: {
                    title: 'Atualizar versão',
                    informe_versao: 'Ou informe a versão',
                    update_button: 'Atualizar',
                    sucesso: 'Comando enviado com sucesso!',
                    error: 'Erro ao enviar comando, verifique o LOG!'
                },
                atividade: {
                    title: 'Acionar atividade VNS',
                    informe_comando: 'Informe o comando',
                    send_button: 'Enviar Comando',
                    sucesso: 'Comando enviado com sucesso!',
                    error: 'Erro ao enviar comando, verifique o LOG!',
                    comando_para_vns: 'Comando para VNS'
                }
            },
            latencia: {
                title: 'Latência',
                tabs: {
                    ultimo: 'Último',
                    historico: 'Histórico',
                },
                little_cards: {
                    ip_interno: 'IP Interno',
                    ip_externo: 'IP Externo',
                    ultima_atualizacao: 'Última atualização',
                    latencia: 'Latência Média',
                    disco: 'Disco Livre',
                    cpu: 'CPU',
                    periodo: 'Período',
                    minutos: 'Minutos',
                    hora: 'Hora',
                    personalizado: 'Personalizado',
                    cancelar: 'Cancelar'
                }
            },
            temperatura: {
                title: 'Temperatura',
                little_cards: {
                    temperatura: 'Temperatura',
                    umidade: 'Umidade'
                }
            },
            localizacao: {
                title: 'Localização',
                ultima: 'Última Localização',
                nenhuma_localizacao: 'Nenhuma Localização encontrada.',
            },
            log_panel: {
                codigo_erro: 'Código do Erro:',
                vns_equipamento: 'VNS/Equipamento',
                tipo: 'Tipo',
                data_hora: 'Data/Hora',
                acao: 'Ação',
                ver_log: 'Ver log',
                alerta_vns: 'Alerta VNS'
            },
            jira: {
                title: 'Jira',
                tabela_titulo: {
                    tipo: 'tipo',
                    status: 'status',
                    data_atualizacao: 'data_de_atualização'
                }
            }
        }
    },
    detalhe:{
        table: {
            consumo_total: 'Consumo total',
            empresas: 'Empresas',
            unidades: 'Unidades',
            tipo: 'Tipo',
            equipamento: 'Equipamento',
            com_alertas: 'Com Alertas',
            empresa: 'Empresa',
            unidade: 'Unidade',
            apelido: 'Apelido',
            ip_interno: 'IP Interno',
            ip_externo: 'IP Externo',
            latencia: 'Latência',
            impressora: 'Impressora',
            recebidos: 'Bytes Recebidos',
            enviados: 'Bytes Enviados',
            disco_livre: 'Disco Livre',
            vns_detalhados: 'VNS\'s Detalhados',
            filtro_indisponivel: 'Filtro indisponível'
        }
    },
    jira: {
        tipos_problema: {
            ip: 'Problema de Comunicação',
            temperatura: 'Problema de Temperatura'
        },
        table: {
            empty: 'Nenhum jira encontrado'
        }
    }
}
// irineu de melo